import { useMemo } from "react";

import { useRepContext } from "../contexts/editableItemContext";
import { useUserContext } from "../contexts/userContext";
import { RepStatusEnum } from "../models/rep";

export const usePermissionsCheck = () => {
	const { rep } = useRepContext();
	const { user } = useUserContext();

	const fullAPReadOnly = useMemo(() => {
		if (rep.statusEnum === RepStatusEnum.Terminated && !user.userIsAdmin) return true;
		return false;
	}, [rep, user]);

	return { fullAPReadOnly };
};
